import i18next from "../i18n";
import { showErrorModal } from "./errormodal";

export function initializeSigningButton() {
  $("#sign-sales-order-btn").on("click", function (event) {
    event.preventDefault();

    const campaignId = $(this).data("campaign-id");
    const salesOrderId = $(this).data("sales-order-id");

    $("#signingLoadingModal").modal("hide");

    $.ajax({
      type: "POST",
      url: `/manager/campaigns/${campaignId}/salesorder/${salesOrderId}/sign`,
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      success: function (response) {
        $("#signingLoadingModal").modal("hide");
        window.location.href = decodeURI(response);
      },
      error: function (xhr) {
        console.error("AJAX Error:", xhr.status, xhr.responseText);

        $("#signingLoadingModal").modal("hide");
        if (xhr.status === 409) {
          try {
            const conflictResponse = JSON.parse(xhr.responseText);
            console.log("Conflict response:", conflictResponse); // TODO: Remove this line after testing
            if (
              conflictResponse.expires_in &&
              conflictResponse.expires_in.includes("Another user is already viewing")
            ) {
              console.log("Showing conflict modal"); // TODO: Remove this line after testing
              $("#signingConflictModal").modal("show");
              return;
            }
          } catch (e) {
            console.error("Error parsing conflict response:", e);
          }
        }
        showErrorModal(i18next.t(xhr.responseText));
      },
    });
  });
}
